import { render, staticRenderFns } from "./departmentfeepay.vue?vue&type=template&id=77286f28&"
import script from "./departmentfeepay.vue?vue&type=script&lang=js&"
export * from "./departmentfeepay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports